module.exports = __webpack_public_path__ + "img/s1v2t1.c7b1cc45.jpeg";